// frontend/src/components/member-dashboard/components/BillingBanner.js
import React from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCreditCard,
  faExclamationTriangle,
} from "@fortawesome/free-solid-svg-icons";
import "./BillingBanner.css";

/**
 * BillingBanner component for displaying a prompt to add a payment method
 * @param {Object} props - Component props
 * @param {string} props.userId - User ID
 * @returns {JSX.Element} - Rendered component
 */
const BillingBanner = ({ userId }) => {
  const navigate = useNavigate();

  /**
   * Handle click on "Add Payment Method" button
   */
  const handleAddPaymentMethod = () => {
    navigate("/payment");
  };

  return (
    <div className="billing-banner">
      <div className="billing-banner-icon">
        <FontAwesomeIcon icon={faExclamationTriangle} />
      </div>
      <div className="billing-banner-content">
        <h3>Payment Method Required</h3>
        <p>
          You need to add a payment method before you can book sessions. Your
          card will not be charged unless you have a membership or purchase a
          package or drop-in session.
        </p>
        <button className="add-payment-button" onClick={handleAddPaymentMethod}>
          <FontAwesomeIcon icon={faCreditCard} /> Add Payment Method
        </button>
      </div>
    </div>
  );
};

BillingBanner.propTypes = {
  userId: PropTypes.string.isRequired,
};

export default BillingBanner;
